import { observer } from 'mobx-react';
import { translate } from '~/filters';

type ModalSlotProps = {
  options: any;
  close: () => void;
};

const ModalSlot = ({ options, close }: ModalSlotProps) => {
  const onClickButton = (button: any) => {
    close();
    if (button.onClick) {
      button.onClick();
    }
  };

  return (
    <div className="modal-slot modal-consulting-evnt">
      <div className="head flex-row flex-between items-start">
        <div className={`title ${options.titleClass || ''}`}>
          {translate(options.title)}
        </div>
        {options.showCloseButton ? (
          <i onClick={() => close()} className="zmdi zmdi-close" />
        ) : null}
      </div>
      {/* preparedDom must be a function that returns a DOM */}
      {options.preparedDom ? options.preparedDom() : null}
      {options.buttons ? (
        <div className="buttons">
          <div className="flex-row">
            {options.buttons.map((button: any, idx: number) => {
              return (
                <button
                  key={idx}
                  onClick={() => onClickButton(button)}
                  className={button.class}
                >
                  {translate(button.text)}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default observer(ModalSlot);
